import React from "react";
import {Input} from "antd";
import {SplitInputWrapperProps, InputWrapper} from "../../functions";
import {PasswordInputBoxProps} from "./interface";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const PasswordInputBox: React.FC<PasswordInputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.text());
    }

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <Input.Password {...inputProps} />
        </InputWrapper>
    );
};

export default PasswordInputBox;
